import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
//import formData from "/src/utils/formData";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import ButtonAction from "/src/components/UI/Button/Button";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "/src/components/UI/ChooseFile/ChooseFile.css";
import "../DashboardVariable.css";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
import DropDown from "/src/components/UI/DropDown/DropDown";
import {launchFireworks} from "/src/components/fireworks/firework";

const DashboardButtonConfirmationModal = NiceModal.create(({ data, postbackAction, channels }) => {
    const modal = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const [resultButton, setResultButton] = useState(false)
    const title = data.default_value;
    data.regex = !data.regex ? "" : data.regex; 
    const content = data.regex.substring(data.regex.indexOf('\n') + 1);
    const { onClose } = useModalHelper(modal);
    const { register, getValues, setValue, handleSubmit, watch, formState: { errors }, formState } = useForm({
        mode: "onChange",
        defaultValues: "",
    });
    const onSubmit = async () => {
        setIsLoading("start");
        let res = await postbackAction(getValues().channel_key);
        setIsLoading("finish");
        if (data.placeholder_format != null) {
            setTimeout(() => setResultButton(res.data), 2000)
        }
        else {
            setTimeout(() =>{onClose(); launchFireworks()}, 2000)
        }
        launchFireworks() // 2 fois pour faire plus joli & dans le cas ou la modal se ferme pas, on le voit pour sur
    };
    return (
        <Modal name={resultButton != false ? "modal_button_dashboard_result_adapted" : ""} id={modal.id} onClose={onClose} >
            <div className="leave-container">
                <div className="button-leave" onClick={onClose} >
                    <i className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            {
                isLoading == false &&
                <Form className="changePassword-container" onSubmit={handleSubmit(onSubmit)}>
                    <Form.Title>{data.label}</Form.Title>
                    <Form.Body>
                        <p style={{ fontSize: "16px", whiteSpace: "pre-line" }}>
                            {content}
                        </p>

                        <div>
                            <p style={{ fontSize: "16px" }}>
                                Tap the name of the variable : <span style={{ fontWeight: "bold" }} >{data.label}</span>
                            </p>
                            <TextInput {...register("confirmation_input")} style={{ marginBottom: "15px", borderColor: !watch("confirmation_input") ? '' : (watch("confirmation_input") != data.label ? 'var(--pink)' : '') }}></TextInput>
                        </div>
                        {
                            channels.length > 0 &&
                            <div style={{ display :"flex",    marginBottom: "15px"}}>
                                <Field label="Channel" listLabelClassName="titles-input"></Field>
                                <div style={{ marginLeft: "10%", marginTop: "2%"}}>
                                    <DropDown {...register('channel_key')} setValue={setValue} choices={channels} defaultChoice={channels[0].id } width="230px"></DropDown>
                                </div>
                            </div>
                        }

                    </Form.Body>
                    <Form.Buttons>
                        <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                        <ButtonAction className="validate" label="Go" type="submit" disabled={!(watch("confirmation_input") == data.label)} />
                    </Form.Buttons>
                </Form>
            }
            {
                isLoading != false &&
                <div id="border_anim" className={'container_loader_button ' + (resultButton != false ? "moove_loader_to_up" : "")}>
                    <div id={"border_anim"} style={{ display: "flex" }}>
                        <svg id="svg_checkfile" viewBox="0 0 52 52" className="checkmark" style={{ display: isLoading == "finish" ? "block" : "none", left: "44%" }}>
                            <circle className="checkmark__circle" cy="26" cx="26" r="25" fill="none"></circle>
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                        </svg>
                        {
                            isLoading == "start" &&
                            < div id="loader_anim" className="loader">
                                <div className="load-one" style={{ left: "43%" }}></div>
                                <div className="load-two" style={{ left: "45.2%" }}></div>
                                <div className="load-three" style={{ left: "47.5%" }}></div>
                            </div>
                        }

                    </div>
                </div>
            }
            {
                resultButton != false &&
                resultButton.messages.map((element, i) => {
                    return (
                        <div style={{ textAlign: "center" }}>
                            <span style={{ color: element.type == "error" ? "var(--pink)" : "var(--main)" }}>{capitalizeFirstLetter(element.type)} </span>: {element.content}

                        </div>

                    )

                })
            }

        </Modal >
    )
});

export default DashboardButtonConfirmationModal;